function createForm(action: string): HTMLFormElement {
  const form = window.document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('target', '_blank');
  form.setAttribute('action', action);
  form.setAttribute('aria-label', 'prg');
  return form;
}

function submitForm(form: HTMLFormElement): void {
  window.document.body.appendChild(form);
  form.submit();
  setTimeout(() => window.document.body.removeChild(form), 0);
}

// Implementation of PRG pattern (needs to be sure that particular server supports it)
// (https://en.wikipedia.org/wiki/Post/Redirect/Get)
// Handy to use e.g. with links (html `a` tag)
export function makePRGAction(action: string | undefined): void {
  submitForm(createForm(action ?? ''));
}
